import React from 'react';
import Footer from '../../../../common/table/Footer';
import { connect } from 'react-redux';
import Const from '../Const';
import TopInfoStrategy from './../common-top-info/TopInfoStrategy';
import TaStrategyTable from './../table/TaStrategyTable';
import MarketAbnormallyTable from './../table/MarketAbnormallyTable';
import './index.scss';
import TabFilterTaStrategy from './TabFilter';
import { REDUCER_NAME } from '../reducer';
import { I18n } from 'react-redux-i18n';

class TabContent extends React.Component {
  getTableTitle = () => {
    const { currentTab, breakOutType } = this.props;
    const mapTitle = {
      [Const.tabs.accummulation]: 'taStrategy.tableAccumulation',
      [Const.tabs.breakOut]:
        breakOutType === Const.filterBreakout.breakOutType.TOP
          ? 'taStrategy.tableBreakOut'
          : 'taStrategy.tableBreakOutBottom',
      [Const.tabs.breakOutMa]: 'taStrategy.tableBreakOutMa',
      [Const.tabs.bestInDowntrend]: 'taStrategy.tableBestInDowntrend',
      [Const.tabs.marketAnomaly]: 'taStrategy.tableMarketAnomaly',
    };
    return mapTitle[currentTab];
  };

  getSchemaKey = () => {
    const { currentTab, breakOutType } = this.props;
    const map = {
      [Const.tabs.accummulation]: Const.tableAccumulation,
      [Const.tabs.breakOut]:
        breakOutType === Const.filterBreakout.breakOutType.TOP
          ? Const.tableBreakOut
          : Const.tableBreakOutBottom,
      [Const.tabs.breakOutMa]: Const.tableBreakOutMa,
      [Const.tabs.bestInDowntrend]: Const.tableBestInDowntrend,
      [Const.tabs.marketAnomaly]: Const.tableMarketAnomaly,
    };
    return map[currentTab];
  };

  getDefaultFilterTab = () => {
    const { currentTab, filterData } = this.props;
    let marketAnomalyFilterLineOne = 'taStrategy.filterHighestReturnDaily';
    if (currentTab === Const.tabs.marketAnomaly) {
      if (
        filterData[currentTab].checkboxMarketNormally ===
        Const.filterMarketAbnormally.optionTime.Daily
      ) {
        marketAnomalyFilterLineOne = 'taStrategy.filterHighestReturnDaily';
      }
      if (
        filterData[currentTab].checkboxMarketNormally ===
        Const.filterMarketAbnormally.optionTime.Monthly
      ) {
        marketAnomalyFilterLineOne = 'taStrategy.filterHighestReturnMonthly';
      }
      if (
        filterData[currentTab].checkboxMarketNormally ===
        Const.filterMarketAbnormally.optionTime.Quarterly
      ) {
        marketAnomalyFilterLineOne = 'taStrategy.filterHighestReturnQuarterly';
      }
    }
    const map = {
      [Const.tabs.accummulation]: [
        'taStrategy.filterAccumulationPeriod',
        'taStrategy.filterVolumnRateOfChangeTabOne',
        'taStrategy.filterIncreaseInPriceTabOne',
      ],

      [Const.tabs.breakOut]: [
        'taStrategy.filterBreakoutTopWithin',
        'taStrategy.filterVolumnRateOfChangeTabTwo',
        'taStrategy.filterStockGroupTabTwo',
      ],

      [Const.tabs.breakOutMa]: [
        'taStrategy.filterBreakoutMaBottom',
        'taStrategy.filterVolumnRateOfChangeTabThree',
        'taStrategy.filterIncreaseInPriceTabThree',
      ],

      [Const.tabs.bestInDowntrend]: [
        'taStrategy.filterVNIndexDowntrend',
        'taStrategy.filterAverageVol1mTabFour',
        'taStrategy.filterStockGroupTabFour',
      ],

      [Const.tabs.marketAnomaly]: [
        marketAnomalyFilterLineOne,
        'taStrategy.filterCaculationPeriod',
        'taStrategy.filterAverageVol1mTabFive',
        'taStrategy.filterStockGroupTabFive',
      ],
    };
    return map[currentTab];
  };

  getTitleFilter = () => {
    const { currentTab, breakOutType } = this.props;
    const map = {
      [Const.tabs.accummulation]: [
        'taStrategy.titleFilterAccumulation.titleOne',
        'taStrategy.titleFilterAccumulation.titleTwo',
        'taStrategy.titleFilterAccumulation.titleThree',
      ],

      [Const.tabs.breakOut]: [
        breakOutType === Const.filterBreakout.breakOutType.TOP
          ? 'taStrategy.titleFilterBreakout.titleOne'
          : 'taStrategy.titleFilterBreakoutBottom.titleOne',
        'taStrategy.titleFilterBreakout.titleTwo',
        'taStrategy.titleFilterBreakout.titleThree',
      ],

      [Const.tabs.breakOutMa]: [
        'taStrategy.titleFilterBreakoutMa.titleOne',
        'taStrategy.titleFilterBreakoutMa.titleTwo',
        'taStrategy.titleFilterBreakoutMa.titleThree',
      ],

      [Const.tabs.bestInDowntrend]: [
        'taStrategy.titleFilterBestInDowntrend.titleOne',
        'taStrategy.titleFilterBestInDowntrend.titleTwo',
        'taStrategy.titleFilterBestInDowntrend.titleThree',
      ],

      [Const.tabs.marketAnomaly]: [
        'taStrategy.titleFilterMarketAnomaly.titleOne',
        'taStrategy.titleFilterMarketAnomaly.titleTwo',
        'taStrategy.titleFilterMarketAnomaly.titleThree',
        'taStrategy.titleFilterMarketAnomaly.titleFour',
      ],
    };
    return map[currentTab];
  };

  getInfoStrategy = () => {
    const { currentTab } = this.props;
    const map = {
      [Const.tabs.accummulation]: {
        summaryName: I18n.t(`taStrategy.overviewAccummulation.leftTick`),
        name: I18n.t(`taStrategy.overviewAccummulation.rightName`),
        characteristics: I18n.t(
          `taStrategy.overviewAccummulation.rightCharacteristics`,
        ),
        color: '#5392ff',
      },

      [Const.tabs.breakOut]: {
        summaryName: I18n.t(`taStrategy.overviewBreakOut.leftTick`),
        name: I18n.t(`taStrategy.overviewBreakOut.rightName`),
        characteristics: I18n.t(
          `taStrategy.overviewBreakOut.rightCharacteristics`,
        ),
        color: '#e24938',
      },

      [Const.tabs.breakOutMa]: {
        summaryName: I18n.t(`taStrategy.overviewBreakOutMa.leftTick`),
        name: I18n.t(`taStrategy.overviewBreakOutMa.rightName`),
        characteristics: I18n.t(
          `taStrategy.overviewBreakOutMa.rightCharacteristics`,
        ),
        color: '#f0b04f',
      },

      [Const.tabs.bestInDowntrend]: {
        summaryName: I18n.t(`taStrategy.overviewBestInDowntrend.leftTick`),
        name: I18n.t(`taStrategy.overviewBestInDowntrend.rightName`),
        characteristics: I18n.t(
          `taStrategy.overviewBestInDowntrend.rightCharacteristics`,
        ),
        color: '#5b4587',
      },

      [Const.tabs.marketAnomaly]: {
        summaryName: I18n.t(`taStrategy.overviewMarketAnomaly.leftTick`),
        name: I18n.t(`taStrategy.overviewMarketAnomaly.rightName`),
        characteristics: I18n.t(
          `taStrategy.overviewMarketAnomaly.rightCharacteristics`,
        ),
        color: '#f59b9b',
      },
    };
    return map[currentTab];
  };

  render() {
    const { currentTab, filterData, onSort } = this.props;
    const filterTypeTab = this.getDefaultFilterTab();
    const infoStrategy = this.getInfoStrategy();
    const titleFilter = this.getTitleFilter();
    return (
      <div className="body-strategy-ta d-flex flex-fill flex-column px-20">
        <TopInfoStrategy currentTab={currentTab} infoStrategy={infoStrategy} />
        <TabFilterTaStrategy
          currentTab={currentTab}
          titleFilter={titleFilter}
          filterTypeTab={filterTypeTab}
        />
        <div className="mt-10 d-flex flex-fill flex-column top-mover-content">
          {currentTab !== Const.tabs.marketAnomaly && (
            <TaStrategyTable
              onSort={onSort}
              title={this.getTableTitle()}
              schemaKey={this.getSchemaKey()}
              currentTab={currentTab}
              listHideColumn={Const.listHideColumn}
              filterData={filterData}
            />
          )}
          {currentTab === Const.tabs.marketAnomaly && (
            <MarketAbnormallyTable
              onSort={onSort}
              title={this.getTableTitle()}
              schemaKey={this.getSchemaKey()}
              currentTab={currentTab}
              listHideColumn={Const.listHideColumn}
              filterData={filterData}
            />
          )}
        </div>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    i18n: state.i18n,
    filterData: state[REDUCER_NAME].filterData,
    breakOutType:
      state[REDUCER_NAME].filterData[state[REDUCER_NAME].currentTabData]
        .breakOutType,
  };
};

export default connect(mapStateToProps)(TabContent);
